export default "__VITE_ASSET__OOm2gKOQ__"